import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../dotcom2024.service';

@Component({
  selector: 'app-people',
  standalone: true,
  imports: [],
  templateUrl: './people.component.html',
  styleUrl: './people.component.css'
})
export class PeopleComponent implements OnInit{

  constructor(private title: Title, private meta: Meta, public dotComService: Dotcom2024Service) {
  }
  
  ngOnInit(): void {
    this.dotComService.activePage = "people"

    this.title.setTitle("meta title tag description here- people");
    this.meta.updateTag({ name: 'description', content: "meta tag description here - people" });
    this.meta.updateTag({ property: 'og:title', content: "og title here - people" });
    this.meta.updateTag({ property: 'og:description', content: "og:description here - people" });
    this.meta.updateTag({ property: 'og:image', content: "og:image here - people" });
    this.meta.updateTag({ property: 'og:url', content: "og:url here - people" });
    this.meta.updateTag({ property: 'Twitter:card', content: "twitter:card here - people" });    
    this.meta.updateTag({ property: 'Twitter:site', content: "twitter:site here - people" });    
    this.meta.updateTag({ property: 'Twitter:title', content: "twitter:title here - people" });
    this.meta.updateTag({ property: 'Twitter:description', content: "twitter:description here - people" });
    this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - people" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - people" });  
  }

}
